import type { Game } from "../types/Game";
import { GameCard } from "./GameCard";

interface GameGridProps {
	games: Game[];
	emptyMessage?: string;
}

/**
 * Responsive grid of game cards. 2 columns on mobile, up to 4 on desktop.
 */
export function GameGrid({
	games,
	emptyMessage = "No games match your filters.",
}: GameGridProps) {
	if (games.length === 0) {
		return (
			<div className="py-16 text-center text-ink-muted">
				{emptyMessage}
			</div>
		);
	}
	return (
		<div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
			{games.map((g) => (
				<GameCard key={g.id} game={g} />
			))}
		</div>
	);
}
